export enum Organization {
  AFAGHTEL = 'AFAGHTEL',
  ROHAMCEL = 'ROHAMCEL',
  MOHAYMEN = 'MOHAYMEN',
}

export const TRANSLATE: { [key in Organization]: string } = {
  [Organization.AFAGHTEL]: 'آفاق‌تل',
  [Organization.ROHAMCEL]: 'رهام‌سل',
  [Organization.MOHAYMEN]: 'مهیمن',
}
